import * as React from 'react';

import PropTypes from 'prop-types';

import {ChevronLeftIcon, ChevronRightIcon} from '../icon';

import {CalendarYearPicker} from './calendar-year-picker';

import styles from './calendar-header.module.css';

export class CalendarHeader extends React.Component {
    static propTypes = {
        hasLeftControl: PropTypes.bool.isRequired,
        hasRightControl: PropTypes.bool.isRequired,
        hasYearPicker: PropTypes.bool,
        dateFormat: PropTypes.string.isRequired,
        momentDisplayDate: PropTypes.object.isRequired,
        onYearChange: PropTypes.func,
        onLeftClick: PropTypes.func,
        onRightClick: PropTypes.func,
        isLightMode: PropTypes.bool,
    };

    static defaultProps = {
        dateFormat: 'MMMM',
    };

    render() {
        const momentDisplayDate = this.props.hasYearPicker
            ? this.props.momentDisplayDate.format(this.props.dateFormat)
            : `${this.props.momentDisplayDate.format(
                  this.props.dateFormat
              )} ${this.props.momentDisplayDate.get('year')}`;

        return (
            <div
                className={this.props.isLightMode ? styles['container-light'] : styles['container']}
            >
                {this.props.hasLeftControl ? (
                    <div
                        onClick={this.props.onLeftClick}
                        type='button'
                        className={styles['button-control']}
                    >
                        <ChevronLeftIcon />
                    </div>
                ) : (
                    <div className={styles['button']} />
                )}
                <div className={styles['month']}>
                    {momentDisplayDate}
                    {this.props.hasYearPicker ? (
                        <CalendarYearPicker
                            year={this.props.momentDisplayDate.get('year')}
                            onChange={this.handleYearChange}
                            isLightMode={this.props.isLightMode}
                        />
                    ) : undefined}
                </div>
                {this.props.hasRightControl ? (
                    <div
                        onClick={this.props.onRightClick}
                        type='button'
                        className={styles['button-control']}
                    >
                        <ChevronRightIcon />
                    </div>
                ) : (
                    <div className={styles['button']} />
                )}
            </div>
        );
    }

    handleYearChange = (newYear) => {
        const newDisplayDate = this.props.momentDisplayDate.clone().set({year: newYear});
        this.props.onYearChange(newDisplayDate);
    };
}
